import React, { useState } from 'react';

const Button15 = ({
    children,
    onClick,
    variant = 'primary',
    className = '',
    disabled = false,
    type = 'button',
}) => {
    const [hovered, setHovered] = useState(false);

    const baseStyle = {
        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
        fontSize: '14px',
        fontWeight: 600,
        letterSpacing: '1px',
        textTransform: 'uppercase',
        padding: '14px 32px',
        border: 'none',
        borderRadius: '9999px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        textDecoration: 'none',
    };

    const variants = {
        primary: {
            default: {
                backgroundColor: '#1E40AF',
                color: '#FFFFFF',
                border: '2px solid #1E40AF',
            },
            hover: {
                backgroundColor: '#1E3A8A',
                color: '#FFFFFF',
                border: '2px solid #1E3A8A',
            },
        },
        outline: {
            default: {
                backgroundColor: 'transparent',
                color: '#1E40AF',
                border: '2px solid #1E40AF',
            },
            hover: {
                backgroundColor: '#1E40AF',
                color: '#FFFFFF',
                border: '2px solid #1E40AF',
            },
        },
        ghost: {
            default: {
                backgroundColor: 'transparent',
                color: '#1E40AF',
                border: '2px solid transparent',
            },
            hover: {
                backgroundColor: 'rgba(30, 64, 175, 0.08)',
                color: '#1E40AF',
                border: '2px solid transparent',
            },
        },
    };

    const currentVariant = variants[variant] || variants.primary;
    const variantStyle = hovered && !disabled ? currentVariant.hover : currentVariant.default;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;600&display=swap');
            `}</style>
            <button
                type={type}
                onClick={disabled ? undefined : onClick}
                disabled={disabled}
                className={className}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                style={{ ...baseStyle, ...variantStyle }}
            >
                {children}
            </button>
        </>
    );
};

export default Button15;
